/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCustomToolCallInputDoneEvent = {
  type: "response.custom_tool_call_input.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  input: string;
};

/** @internal */
export const ResponseCustomToolCallInputDoneEvent$inboundSchema: z.ZodType<
  ResponseCustomToolCallInputDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.custom_tool_call_input.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  input: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseCustomToolCallInputDoneEvent$Outbound = {
  type: "response.custom_tool_call_input.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  input: string;
};

/** @internal */
export const ResponseCustomToolCallInputDoneEvent$outboundSchema: z.ZodType<
  ResponseCustomToolCallInputDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseCustomToolCallInputDoneEvent
> = z.object({
  type: z.literal("response.custom_tool_call_input.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  input: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseCustomToolCallInputDoneEventToJSON(
  responseCustomToolCallInputDoneEvent: ResponseCustomToolCallInputDoneEvent,
): string {
  return JSON.stringify(
    ResponseCustomToolCallInputDoneEvent$outboundSchema.parse(
      responseCustomToolCallInputDoneEvent,
    ),
  );
}
export function responseCustomToolCallInputDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseCustomToolCallInputDoneEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCustomToolCallInputDoneEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseCustomToolCallInputDoneEvent' from JSON`,
  );
}
